import React, { useState, useContext } from "react";
import { MyContext } from "../MyContext";
import banner from "../assets/Banner_hero.webp";

import twoWheeler from "../assets/two_wheeler.webp";
import threeWheeler from "../assets/three_wheeler.webp";
import fourWheeler from "../assets/four_wheeler.webp";
import miniTruck from "../assets/mini_truck.webp";
import "./Hero.scss";

import { PiMapPinFill } from "react-icons/pi";
import { FaTruck } from "react-icons/fa";
import { RiMotorbikeFill } from "react-icons/ri";
import { IoMan } from "react-icons/io5";
import { FaCity } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoMdArrowDropdown } from "react-icons/io";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const services = [
  { label: "Two Wheeler", icon: twoWheeler },
  { label: "Three Wheeler", icon: threeWheeler },
  { label: "Four Wheeler", icon: fourWheeler },
  { label: "Mini Truck", icon: miniTruck },
];

const cities = [
  "Chennai",
  "Coimbatore",
  "Ahmedabad",
  "Bangalore",
  "Chandigarh",
  "Delhi",
  "Hyderabad",
  "Indore",
  "Jaipur",
  "Kanpur",
  "Kochi",
  "Kolkata",
  "Lucknow",
  "Ludhiana",
  "Mumbai",
  "Nagpur",
  "Nashik",
  "Pune",
  "Surat",
  "Trivandrum",
  "Vadodara",
  "Visakhapatnam",
];

const HeroSection = () => {
  const { selectedCity, setSelectedCity } = useContext(MyContext);

  return (
    <div className="hero-section d-flex flex-column align-items-center justify-content-end">
      {/* Background Image */}
      <div className="image-section d-flex gap-1 position-absolute top-0 start-0 w-100 h-100 z-n1">
        <img src={banner} alt="glare" className="hero-img" />
        {/* Overlay */}
        <div className="image-overlay position-absolute top-0 start-0 w-100 h-100"></div>
      </div>

      {/* Foreground Text */}
      <div className="text-section justify-content-center d-flex w-100 mt-5 pt-5">
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ width: "100%" }}
        >
          <div
            className="d-flex flex-column align-items-center shadow mt-5"
            style={{
              background: "rgba(237, 241, 249, 0.5)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              padding: "3rem",
              borderRadius: "20px",
            }}
          >
            <div className="d-flex align-items-start mb-3 p-2 gap-1 justify-content-between">
              <div
                style={{ maxWidth: "55%" }}
                className="d-flex flex-column gap-2"
              >
                <h2 className="d-flex flex-column gap-2 ">
                  Your Restaurant’s Secret Ingredient for Fast Deliveries!
                </h2>
                <span
                  className="text-grey "
                  style={{ fontWeight: "200" }}
                >{`Get Your Estimate - Fast & Easy (20 mins)`}</span>
              </div>

              <div className="d-flex justify-content-end align-items-end h-100 w-100  ">
                <div
                  className=" bg-light p-2 d-flex justify-content-between align-items-end gap-1"
                  style={{ borderRadius: "20px", fontWeight: "200" }}
                >
                  <PiMapPinFill size={20} color="#be3624" className="mb-1" />{" "}
                  City:
                  <DropdownButton
                    id="dropdown-basic-button"
                    title={selectedCity}
                    className="custom-dropdown-btn justify-content-center d-flex"
                    style={{ minWidth: "110px", color: 'black !important' }}
                  >
                    {cities.map((city, index) => {
                      return (
                        <Dropdown.Item
                          key={index}
                          onClick={() => setSelectedCity(city)}
                          className="dropdown-item"
                        >
                          {city}
                        </Dropdown.Item>
                      );
                    })}
                    <Dropdown.Item href="#/action-2">
                      Another action
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-3">
                      Something else
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-between w-100 services-container">
  {services.map((service, idx) => (
    <div
      key={idx}
      className="text-center d-flex flex-column mt-3 justify-content-center align-items-center p-3"
      style={{
        width: "210px",
        background: "#edf1f9",
        borderRadius: "10%",
      }}
    >
      <img
        src={service.icon}
        alt=""
        style={{ width: "auto", height: "70px" }}
        className="d-flex align-items-center justify-content-center mb-2 overflow-hidden"
      />
      <p
        className="text-center d-flex"
        style={{
          maxWidth: "90px",
          wordWrap: "break-word",
          fontSize: "14px",
        }}
      >
        {service.label}
      </p>
    </div>
  ))}
</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
